import { captureException } from '@/utils/track'
import * as Sentry from '@sentry/browser'

const fpPromise = window.FingerprintJS.load()

/**
 * 生成浏览器指纹（注意：会阻塞接口，直接存在本地降低影响）
 */
const loadVisitorId = async () => {
    try {
        const load = async () => {
            const fp = await fpPromise

            const { visitorId } = await fp.get()

            localStorage.setItem('gwfp', visitorId)

            return visitorId
        }

        console.time('loadVisitorId')

        const cachedVisitorId = localStorage.getItem('gwfp')

        // 已缓存指纹，则直接使用已缓存的值，并异步更新一次本地存储的值
        if (cachedVisitorId) {
            load()

            Sentry.setTag('user.gwfp', cachedVisitorId)
            console.timeEnd('loadVisitorId')

            return cachedVisitorId
        }

        // 无缓存值，则需要同步加载
        const visitorId = await load()

        Sentry.setTag('user.gwfp', visitorId)
        console.timeEnd('loadVisitorId')

        return visitorId
    } catch (e) {
        console.error('catchError', e)
        captureException(e, {
            anchor: 'getVisitorId',
        })
    }

    return ''
}

let _promise = null

/**
 * 初始化浏览器指纹
 */
export const initVisitorId = () => {
    return getVisitorId()
}

/**
 * 获取浏览器指纹
 */
export const getVisitorId = () => {
    if (!_promise) {
        _promise = loadVisitorId()
        return _promise
    }

    return _promise
}
